import { render, staticRenderFns } from "./StyleManagerChangeFavicon.vue?vue&type=template&id=1c0dd3bc&scoped=true"
import script from "./StyleManagerChangeFavicon.vue?vue&type=script&lang=js"
export * from "./StyleManagerChangeFavicon.vue?vue&type=script&lang=js"
import style0 from "./StyleManagerChangeFavicon.vue?vue&type=style&index=0&id=1c0dd3bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0dd3bc",
  null
  
)

export default component.exports